import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=4d40a378&scoped=true&"
import script from "./jobDetails.vue?vue&type=script&lang=js&"
export * from "./jobDetails.vue?vue&type=script&lang=js&"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=4d40a378&scoped=true&lang=css&"
import style1 from "./jobDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40a378",
  null
  
)

export default component.exports